import * as Blockly from 'blockly/core';
import { register as registerIrLearner } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/ir_learner';
import { register as registerIrReceiver } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/ir_receiver';
import { register as registerIrTransmitter } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/ir_transmitter';
import { register as registerLed } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/led';
import { register as registerLedBar } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/led_bar';
import { register as registerPropeller } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/propeller';
import { register as registerPump } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/pump';
import { register as registerRgbLed } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/rgb_led';
import { register as registerServo180 } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/servo_180';
import { register as registerSpearker } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/speaker';
import { register as registerTtMotor } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/tt_motor';
import { register as registerUsbA } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/usb_a';
import { register as registerVibrationMotor } from '@/(routers)/boards/editor/block/generators/arduino/blocks/action/vibration_motor';
import { register as registerBreak } from '@/(routers)/boards/editor/block/generators/arduino/blocks/control/break';
import { register as registerContinue } from '@/(routers)/boards/editor/block/generators/arduino/blocks/control/continue';
import { register as registerDelay } from '@/(routers)/boards/editor/block/generators/arduino/blocks/control/delay';
import { register as registerFor } from '@/(routers)/boards/editor/block/generators/arduino/blocks/control/for';
import { register as registerForVar } from '@/(routers)/boards/editor/block/generators/arduino/blocks/control/for_var';
import { register as registerIf } from '@/(routers)/boards/editor/block/generators/arduino/blocks/control/if';
import { register as registerMillisGet } from '@/(routers)/boards/editor/block/generators/arduino/blocks/control/millis';
import { register as registerWhile } from '@/(routers)/boards/editor/block/generators/arduino/blocks/control/while';
import { register as registerWhileTime } from '@/(routers)/boards/editor/block/generators/arduino/blocks/control/while_time';
import { register as registerOledBar } from '@/(routers)/boards/editor/block/generators/arduino/blocks/display/oled_bar';
import { register as registerOledClear } from '@/(routers)/boards/editor/block/generators/arduino/blocks/display/oled_clear';
import { register as registerOledPrint } from '@/(routers)/boards/editor/block/generators/arduino/blocks/display/oled_print';
import { register as registerSevenSegNumber } from '@/(routers)/boards/editor/block/generators/arduino/blocks/display/seven_seg_numer';
import { register as registerSevenSegString } from '@/(routers)/boards/editor/block/generators/arduino/blocks/display/seven_seg_string';
import { register as registerSdcardClear } from '@/(routers)/boards/editor/block/generators/arduino/blocks/file/sdcard_clear';
import { register as registerSdcardWrite } from '@/(routers)/boards/editor/block/generators/arduino/blocks/file/sdcard_write';
import { register as registerFunc } from '@/(routers)/boards/editor/block/generators/arduino/blocks/function/func';
import { register as registerFuncCall } from '@/(routers)/boards/editor/block/generators/arduino/blocks/function/func_call';
import { register as registerFuncReturn } from '@/(routers)/boards/editor/block/generators/arduino/blocks/function/func_return';
import { register as registerGpsDatetime } from '@/(routers)/boards/editor/block/generators/arduino/blocks/gps/gps_datetime';
import { register as registerGpsDistance } from '@/(routers)/boards/editor/block/generators/arduino/blocks/gps/gps_distance';
import { register as registerGpsLocation } from '@/(routers)/boards/editor/block/generators/arduino/blocks/gps/gps_location';
import { register as registerGpsSpeed } from '@/(routers)/boards/editor/block/generators/arduino/blocks/gps/gps_speed';
import { register as registerBool } from '@/(routers)/boards/editor/block/generators/arduino/blocks/internal/bool';
import { register as registerFloatSevenSeg } from '@/(routers)/boards/editor/block/generators/arduino/blocks/internal/float_seven_seg_';
import { register as registerNumber } from '@/(routers)/boards/editor/block/generators/arduino/blocks/internal/number';
import { register as registerNumberSevenSeg } from '@/(routers)/boards/editor/block/generators/arduino/blocks/internal/number_seven_seg';
import { register as registerSpacer } from '@/(routers)/boards/editor/block/generators/arduino/blocks/internal/spacer';
import { register as registerString } from '@/(routers)/boards/editor/block/generators/arduino/blocks/internal/string';
import { register as registerStringOled } from '@/(routers)/boards/editor/block/generators/arduino/blocks/internal/string_oled';
import { register as registerStringSevenSeg } from '@/(routers)/boards/editor/block/generators/arduino/blocks/internal/string_seven_seg';
import { register as registerAnalogMax } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/analog_max';
import { register as registerArithmetic } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/arithmetic';
import { register as registerComparisonNumber } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/comparison_number';
import { register as registerComparisonString } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/comparison_string';
import { register as registerLogical } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/logical';
import { register as registerLogicalNot } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/logical_not';
import { register as registerMathAbs } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/math_abs';
import { register as registerMathMap } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/math_map';
import { register as registerMathRandom } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/math_random';
import { register as registerMathRound } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/math_round';
import { register as registerMathStddev } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/math_stddev';
import { register as registerOnOff } from '@/(routers)/boards/editor/block/generators/arduino/blocks/operator/on_off';
import { register as registerSchoomyBoard } from '@/(routers)/boards/editor/block/generators/arduino/blocks/schoomy/schoomy_board';
import { register as registerSchoomyBoardSetup } from '@/(routers)/boards/editor/block/generators/arduino/blocks/schoomy/schoomy_board_setup';
import { register as registerAccelerometer } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/accelerometer';
import { register as registerAccelerometerAngle } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/accelerometer_angle';
import { register as registerAlcohol } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/alcohol';
import { register as registerAmmonia } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/ammonia';
import { register as registerBarometricPressure } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/barometric_pressure';
import { register as registerBrightness } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/brightness';
import { register as registerDistance } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/distance';
import { register as registerFlex } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/flex';
import { register as registerGeneralAnalog } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/general_analog';
import { register as registerGeneralDigital } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/general_digital';
import { register as registerHumidity } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/humidity';
import { register as registerInterrupter } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/interrupter';
import { register as registerMagnetic } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/magnetic';
import { register as registerPresence } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/presence';
import { register as registerPressure } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/pressure';
import { register as registerRain } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/rain';
import { register as registerSoilMoisture } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/soil_moisture';
import { register as registerSoilMoistureC } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/soil_moisture_c';
import { register as registerSound } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/sound';
import { register as registerTemperature } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/temperature';
import { register as registerTouch } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/touch';
import { register as registerWaterFlow } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/water_flow';
import { register as registerWaterMeasurement } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/water_flow_measurement';
import { register as registerWaterTemperature } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/water_temperature';
import { register as registerMonitorBluetooth } from '@/(routers)/boards/editor/block/generators/arduino/blocks/serial/monitor_bluetooth';
import { register as registerMonitorGraph } from '@/(routers)/boards/editor/block/generators/arduino/blocks/serial/monitor_graph';
import { register as registerMonitorPrint } from '@/(routers)/boards/editor/block/generators/arduino/blocks/serial/monitor_print';
import { register as registerFader } from '@/(routers)/boards/editor/block/generators/arduino/blocks/switch/fader';
import { register as registerSwitch } from '@/(routers)/boards/editor/block/generators/arduino/blocks/switch/switch';
import { register as registerSwitchSlide } from '@/(routers)/boards/editor/block/generators/arduino/blocks/switch/switch_slide';
import { register as registerSwitchToggle } from '@/(routers)/boards/editor/block/generators/arduino/blocks/switch/switch_toggle';
import { register as registerSwitchVibration } from '@/(routers)/boards/editor/block/generators/arduino/blocks/switch/switch_vibration';
import { register as registerVariable } from '@/(routers)/boards/editor/block/generators/arduino/blocks/variable/variable';

const arduinoGenerator = new Blockly.Generator('Arduino');

registerSchoomyBoard(arduinoGenerator);
registerSchoomyBoardSetup(arduinoGenerator);
registerMonitorPrint(arduinoGenerator);
registerMonitorGraph(arduinoGenerator);
registerMonitorBluetooth(arduinoGenerator);
registerLed(arduinoGenerator);
registerRgbLed(arduinoGenerator);
registerLedBar(arduinoGenerator);
registerSpearker(arduinoGenerator);
registerUsbA(arduinoGenerator);
registerVibrationMotor(arduinoGenerator);
registerServo180(arduinoGenerator);
registerTtMotor(arduinoGenerator);
registerPropeller(arduinoGenerator);
registerPump(arduinoGenerator);
registerIrTransmitter(arduinoGenerator);
registerIrReceiver(arduinoGenerator);
registerIrLearner(arduinoGenerator);
registerTouch(arduinoGenerator);
registerInterrupter(arduinoGenerator);
registerPresence(arduinoGenerator);
registerWaterFlow(arduinoGenerator);
registerWaterMeasurement(arduinoGenerator);
registerDistance(arduinoGenerator);
registerTemperature(arduinoGenerator);
registerBrightness(arduinoGenerator);
registerAccelerometer(arduinoGenerator);
registerAccelerometerAngle(arduinoGenerator);
registerMagnetic(arduinoGenerator);
registerSound(arduinoGenerator);
registerSoilMoisture(arduinoGenerator);
registerSoilMoistureC(arduinoGenerator);
registerPressure(arduinoGenerator);
registerWaterTemperature(arduinoGenerator);
registerFlex(arduinoGenerator);
registerBarometricPressure(arduinoGenerator);
registerHumidity(arduinoGenerator);
registerRain(arduinoGenerator);
registerAlcohol(arduinoGenerator);
registerAmmonia(arduinoGenerator);
registerGeneralDigital(arduinoGenerator);
registerGeneralAnalog(arduinoGenerator);
registerSwitch(arduinoGenerator);
registerSwitchSlide(arduinoGenerator);
registerSwitchVibration(arduinoGenerator);
registerSwitchToggle(arduinoGenerator);
registerFader(arduinoGenerator);
registerGpsLocation(arduinoGenerator);
registerGpsDistance(arduinoGenerator);
registerGpsSpeed(arduinoGenerator);
registerGpsDatetime(arduinoGenerator);
registerSevenSegNumber(arduinoGenerator);
registerSevenSegString(arduinoGenerator);
registerOledPrint(arduinoGenerator);
registerOledBar(arduinoGenerator);
registerOledClear(arduinoGenerator);
registerSdcardWrite(arduinoGenerator);
registerSdcardClear(arduinoGenerator);
registerDelay(arduinoGenerator);
registerIf(arduinoGenerator);
registerFor(arduinoGenerator);
registerForVar(arduinoGenerator);
registerWhile(arduinoGenerator);
registerWhileTime(arduinoGenerator);
registerBreak(arduinoGenerator);
registerContinue(arduinoGenerator);
registerOnOff(arduinoGenerator);
registerAnalogMax(arduinoGenerator);
registerMillisGet(arduinoGenerator);
registerComparisonNumber(arduinoGenerator);
registerComparisonString(arduinoGenerator);
registerLogical(arduinoGenerator);
registerLogicalNot(arduinoGenerator);
registerArithmetic(arduinoGenerator);
registerMathRound(arduinoGenerator);
registerMathRandom(arduinoGenerator);
registerMathAbs(arduinoGenerator);
registerMathStddev(arduinoGenerator);
registerMathMap(arduinoGenerator);
registerVariable(arduinoGenerator);
registerFunc(arduinoGenerator);
registerFuncCall(arduinoGenerator);
registerFuncReturn(arduinoGenerator);
registerFloatSevenSeg(arduinoGenerator);
registerNumber(arduinoGenerator);
registerNumberSevenSeg(arduinoGenerator);
registerString(arduinoGenerator);
registerStringSevenSeg(arduinoGenerator);
registerStringOled(arduinoGenerator);
registerBool(arduinoGenerator);
registerSpacer(arduinoGenerator);

arduinoGenerator.scrub_ = function (block: Blockly.Block, code: string): string {
    const nextBlock = block.nextConnection?.targetBlock();
    const nextCode = nextBlock ? arduinoGenerator.blockToCode(nextBlock) : '';
    return code + nextCode;
};

export { arduinoGenerator };

export function generateArduinoCode(workspace: Blockly.WorkspaceSvg): string {
    try {
        const blocks = workspace.getTopBlocks(false);
        const entry = blocks.find((b) => b.type === 'schoomy_board');
        if (!entry) return '';
        return arduinoGenerator.blockToCode(entry) as string;
    } catch (e) {
        console.error('generateArduinoCode error:', e);
        return '';
    }
}
